import { useNavigate, Link } from 'react-router-dom'
import { MdOutlineKeyboardBackspace } from 'react-icons/md'

const GoBackButton = () => {
  const navigate = useNavigate()
  return (
    <Link
      to={'..'}
      onClick={(e) => {
        e.preventDefault()
        navigate(-1)
      }}
    >
      <MdOutlineKeyboardBackspace className="text-[#002998ef] text-3xl ml-4 absolute hidden xs:block " />
    </Link>
  )
}

export default GoBackButton
